import React, { Component } from 'react';
import styled from 'styled-components';
import { Panel, PanelTitle } from './DashboardPanel';
import { fmt } from '../model/dashboardCalc';
import { DEVICE_STATUS } from '../model/heatPumpDevice';

// 운전현황 탭: 기기별 실시간 운전 목록
class DevicesSection extends Component {
  render() {
    const { devices } = this.props;

    return (
      <Panel>
        <PanelTitle>
          <h2>기기별 실시간 운전 목록</h2>
          <span>지역 및 제조사 필터 적용</span>
        </PanelTitle>
        <TableWrap>
          <table>
            <thead>
              <tr>
                <th>기기 ID</th>
                <th>제조사</th>
                <th>지역</th>
                <th>운전모드</th>
                <th>현재 소비전력</th>
                <th>금일 사용량</th>
                <th>COP</th>
                <th>상태</th>
              </tr>
            </thead>
            <tbody>
              {devices.length === 0 ? (
                <tr>
                  <td colSpan="8">조건에 맞는 기기가 없습니다.</td>
                </tr>
              ) : (
                devices.map((d) => (
                  <tr key={d.id}>
                    <td>{d.id}</td>
                    <td>{d.maker}</td>
                    <td>{d.region}</td>
                    <td>{d.mode}</td>
                    <td>{fmt(d.kw)} kW</td>
                    <td>{fmt(d.today)} kWh</td>
                    <td>{d.cop ? fmt(d.cop, 2) : '—'}</td>
                    <td className={d.status === DEVICE_STATUS.RUN ? 'status-good' : 'status-idle'}>
                      ● {d.status}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </TableWrap>
      </Panel>
    );
  }
}

const TableWrap = styled.div`
  overflow: auto;

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
  }
  th {
    text-align: left;
    color: #849ab6;
    font-weight: 500;
    padding: 13px 10px;
    border-bottom: 1px solid #29394f;
  }
  td {
    padding: 14px 10px;
    border-bottom: 1px solid #1e2d42;
    color: #d2e0f1;
  }
  td.status-good {
    color: #68e4a8;
  }
  td.status-idle {
    color: #f3c47b;
  }

  @media (max-width: 700px) {
    table {
      min-width: 650px;
    }
    td,
    th {
      white-space: nowrap;
    }
  }
`;

export default DevicesSection;
